import React from 'react';
import { Card, CardContent, CardMedia, Typography } from '@mui/material';

/**
 * Displays a team member including headshot, name, role and short bio.
 *
 * @param {Object} props
 * @param {string} props.name - Team member name
 * @param {string} props.role - Team member role or title
 * @param {string} [props.bio] - Optional short bio text
 * @param {string} [props.imageSrc] - Headshot image source
 */
export default function TeamMemberCard({ name, role, bio, imageSrc }) {
  return (
    <Card sx={{ textAlign: 'center', maxWidth: 345, mx: 'auto', boxShadow: 3 }}>
      {imageSrc && (
        <CardMedia
          component="img"
          image={imageSrc}
          alt={name}
          sx={{ height: 240, objectFit: 'cover' }}
        />
      )}
      <CardContent>
        <Typography variant="h6" component="h3" gutterBottom>
          {name}
        </Typography>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          {role}
        </Typography>
        {bio && (
          <Typography variant="body2" color="text.secondary">
            {bio}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
